export default "__VITE_ASSET__EMzPUs2v__"